var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivefalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7271 4.85275L161.278 44.4305C163.253 45.5707 164.469 47.6777 164.469 49.958V129.114C164.469 131.394 163.253 133.501 161.278 134.641L92.7271 174.219C90.7523 175.359 88.3193 175.359 86.3445 174.219L17.7938 134.641C15.819 133.501 14.6025 131.394 14.6025 129.114V49.958C14.6025 47.6777 15.819 45.5707 17.7938 44.4305L86.3445 4.85275C88.3193 3.71262 90.7523 3.71262 92.7271 4.85275Z",
    fill: "#D9D9D9",
    stroke: "url(#paint0_linear_740_520)",
    strokeWidth: 5.21393
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_740_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7526 23.9599C87.5371 22.9296 89.7357 22.9296 91.5202 23.9599L144.141 54.3407C145.926 55.371 147.025 57.275 147.025 59.3356V120.097C147.025 122.158 145.926 124.062 144.141 125.092L91.5202 155.473C89.7357 156.503 87.5371 156.503 85.7526 155.473L33.1314 125.092C31.3469 124.062 30.2476 122.158 30.2476 120.097V59.3356C30.2476 57.275 31.3469 55.371 33.1314 54.3407L85.7526 23.9599Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_740_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7526 23.9599C87.5371 22.9296 89.7357 22.9296 91.5202 23.9599L144.141 54.3407C145.926 55.371 147.025 57.275 147.025 59.3356V120.097C147.025 122.158 145.926 124.062 144.141 125.092L91.5202 155.473C89.7357 156.503 87.5371 156.503 85.7526 155.473L33.1314 125.092C31.3469 124.062 30.2476 122.158 30.2476 120.097V59.3356C30.2476 57.275 31.3469 55.371 33.1314 54.3407L85.7526 23.9599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.902 26.7625L142.523 57.1434C143.306 57.5956 143.789 58.4312 143.789 59.3356V120.097C143.789 121.002 143.306 121.837 142.523 122.29L89.902 152.67C89.1188 153.123 88.1539 153.123 87.3707 152.67L34.7495 122.289C33.9663 121.837 33.4838 121.002 33.4838 120.097V59.3356C33.4838 58.4312 33.9663 57.5956 34.7495 57.1434L87.3707 26.7625C88.1539 26.3104 89.1188 26.3104 89.902 26.7625Z",
    stroke: "url(#paint1_diamond_740_520)",
    strokeWidth: 6.47247
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_740_520",
    x: 27.1717,
    y: 20.1131,
    width: 122.926,
    height: 139.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_740_520",
    x: 27.1717,
    y: 20.1131,
    width: 122.926,
    height: 139.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_520",
    x1: 127.112,
    y1: 157.317,
    x2: 46.1163,
    y2: 23.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.257406
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_740_520",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.6364 89.7164) rotate(90) scale(67.4215 123.256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivefalse);
export default __webpack_public_path__ + "static/media/Active=false.236987cf9215f5e8cccd193969bf84c7.svg";
export { ForwardRef as ReactComponent };